// extracted by mini-css-extract-plugin
export default {"bridge":"Header_bridge__g66hj"};